import { render } from "./의료진프로필.vue?vue&type=template&id=80587b9e"
import script from "./의료진프로필.vue?vue&type=script&lang=js"
export * from "./의료진프로필.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__